import React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import DevolutionForm from "./DevolutionForm.tsx";
import dayjs from "dayjs";
import { deleteDevolution, getDevolutionList } from "../../api/devolutions/index.ts";

const DevolutionTable = () => {
  const { selectedCompany } = useCompany();

  if (!selectedCompany) {
    return (
      <Box p={4}>
        <Typography>Seleccione una compañía primero</Typography>
      </Box>
    );
  }

  const devolutionCrudProps = {
    fetchFunction: getDevolutionList,
    deleteFunction: deleteDevolution,
    data: { companyId: selectedCompany.id },
    detailMenu: [],
    columns: [
      { field: "id", headerName: "ID", flex: 0.05 },
      {
        field: "product",
        headerName: "Producto",
        flex: 0.2,
        valueGetter: (value, row) => {
          return row.product ? `${row.product.code} - ${row.product.description}` : "";
        },
      },
      {
        field: "quantity",
        headerName: "Cantidad",
        flex: 0.1,
        valueGetter: (value, row) => {
          return row.quantity || 0;
        },
      },
      {
        field: "devolutionReason",
        headerName: "Razón de Devolución",
        flex: 0.3,
        valueGetter: (value, row) => {
          return row.devolutionReason || "";
        },
      },
      {
        field: "isWaste",
        headerName: "Es Desperdicio",
        flex: 0.15,
        renderCell: (params) => (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Chip
              size="small"
              label={params.row.isWaste ? "Sí" : "No"}
              color={params.row.isWaste ? "error" : "success"}
            />
          </Box>
        ),
      },
      {
        field: "createdAt",
        headerName: "Fecha de Devolución",
        flex: 0.2,
        valueFormatter: (value) => {
          if (!value) return "-";
          return dayjs(value).format("YYYY-MM-DD");
        },
      },
    ],
    addModalData: {
      header: "Nueva Devolución",
      body: <DevolutionForm onSubmit={() => { }} />,
    },
    editModalData: {
      header: "Editar Devolución",
      body: <DevolutionForm onSubmit={() => { }} />,
    },
    actions: ["create", "delete", "detail"],
    customButtons: [],
  };

  return <LGModalCrud props={devolutionCrudProps} />;
};

export default DevolutionTable; 